import { render, staticRenderFns } from "./CampaignUserNew.vue?vue&type=template&id=611b47c5&scoped=true"
import script from "./CampaignUserNew.vue?vue&type=script&lang=js"
export * from "./CampaignUserNew.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserNew.vue?vue&type=style&index=0&id=611b47c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b47c5",
  null
  
)

export default component.exports